<div class="videoContainer aspectRatio169">
	<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="0" />

	<div
		class="pipVideo {{ pictureInPicturePosition }} "
		[class.isInFullScreenPip]="asPlaybackOptions(cameraLayoutOptionsContainer.options).screens[1]?.isFullScreen"
	>
		@if (isPipEditable) {
			<div class="moveToTop">
				<button
					(click)="setPipVideoPosition('top')"
					mat-mini-fab
					color="accent"
					[disabled]="pictureInPicturePosition.startsWith('Top')"
				>
					<mat-icon fontSet="fad" fontIcon="fa-arrow-up" inline />
				</button>
			</div>
		}

		@if (isPipEditable) {
			<div class="moveToLeft">
				<button
					(click)="setPipVideoPosition('left')"
					mat-mini-fab
					color="accent"
					[disabled]="pictureInPicturePosition.endsWith('Left')"
				>
					<mat-icon fontSet="fad" fontIcon="fa-arrow-left" inline />
				</button>
			</div>
		}

		@if (isPipEditable) {
			<div class="moveToRight">
				<button
					(click)="setPipVideoPosition('right')"
					mat-mini-fab
					color="accent"
					[disabled]="pictureInPicturePosition.endsWith('Right')"
				>
					<mat-icon fontSet="fad" fontIcon="fa-arrow-right" inline />
				</button>
			</div>
		}

		@if (isPipEditable) {
			<div class="moveToBottom">
				<button
					(click)="setPipVideoPosition('bottom')"
					mat-mini-fab
					color="accent"
					[disabled]="pictureInPicturePosition.startsWith('Bottom')"
				>
					<mat-icon fontSet="fad" fontIcon="fa-arrow-down" inline />
				</button>
			</div>
		}

		<sim-screen-container [isSingleView]="false" [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="1" />
	</div>
</div>
